// src/pages/About.js
import React from "react";
import { Link } from "react-router-dom";
import "../index.css";
import useSEO from "../seo/useSEO";

export default function About() {
  // ✅ SEO pour la page À propos
  useSEO({
    title: "À propos — Maxime H, photographe culinaire",
    description:
      "Photographe culinaire basé entre France, Belgique et Luxembourg. Lumière précise, compositions nettes et images prêtes pour web, réseaux et print.",
    canonical: `${window.location.origin}/about`,
    image: `${window.location.origin}/images/og-default.jpg`, // optionnel si tu as une image 1200x630
  });

  return (
    <section className="about-pro">
      <div className="about-flex">
        {/* Colonne gauche : Vidéo */}
        <div className="about-left">
          <div className="about-video">
            <video controls autoPlay muted loop>
              <source src="/videos/ma-video.mp4" type="video/mp4" />
              Votre navigateur ne supporte pas la lecture vidéo.
            </video>
          </div>
        </div>

        {/* Colonne droite : Titre + texte + points + CTA */}
        <div className="about-right">
          {/* Haut : intro + texte narratif */}
          <div className="about-top">
            <h1>
              Je capture l’essentiel : vos produits, vos portraits, vos moments,
              vos lieux.
            </h1>
            <p className="about-lead">
              Je suis <strong>Maxime H</strong>, photographe culinaire.
              Mon approche : une exigence de lumière, des compositions nettes,
              et une lecture simple qui place votre marque au premier plan.
            </p>
            <p>
              J’aime révéler la texture d’un produit, la sincérité d’un portrait,
              l’ambiance d’un lieu, et l’énergie d’un moment. Chaque projet
              commence par l’écoute : objectifs, usages, contraintes,
              calendrier. Puis on construit une direction claire (lumière,
              stylisme, cadrages) pour des images <em>utiles</em> et belles —
              prêtes pour le web, les réseaux et le print.
            </p>
            <p>
              Je travaille en France, en Belgique et au Luxembourg avec les métiers de bouche.
              Packshot précis, reportage vivant, portrait éditorial ou mise en valeur d’espace :
              je vous accompagne de la préparation à la livraison.
            </p>
          </div>

          {/* Bas : points + CTA (proche du texte, moins d'espace blanc) */}
          <div className="about-bottom">
            <ul className="about-points" aria-label="Mes piliers">
              <li>
                <div className="point-ico" aria-hidden>🎯</div>
                <h3>Précision</h3>
                <p>Contrôle de la lumière et des couleurs pour des visuels cohérents et fidèles.</p>
              </li>
              <li>
                <div className="point-ico" aria-hidden>📸</div>
                <h3>Créativité utile</h3>
                <p>Esthétique au service de votre objectif : clarifier, attirer, convertir.</p>
              </li>
              <li>
                <div className="point-ico" aria-hidden>🤝</div>
                <h3>Confiance</h3>
                <p>Communication fluide, repérage, respect des délais et livrables prêts à l’emploi.</p>
              </li>
            </ul>

            <div className="about-cta">
              <Link to="/services" className="btn-solid">Découvrir les services</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}